import clsx from "clsx";

const StatusDisplay = ({ status, className = "" }) => {
  if (!status) {
    return (
      <span className="tw-text-gray-500 tw-text-sm tw-font-medium tw-inline-block">
        Unknown
      </span>
    );
  }

  const statusBase =
    "tw-rounded-lg tw-px-2 tw-py-1 tw-text-sm tw-font-medium tw-inline-block tw-text-center";

  const statusColor =
    status === "Finalized"
      ? "tw-bg-success-light tw-text-white"
      : status === "Reviewing"
      ? "tw-bg-yellow-400 tw-text-black"
      : status === "Missing"
      ? "tw-bg-error-light tw-text-white"
      : "tw-bg-gray-400 tw-text-white";

  return (
    <div className="tw-w-full tw-flex tw-justify-center">
      <span className={clsx(statusBase, statusColor, className)}>{status}</span>
    </div>
  );
};

export default StatusDisplay;
